











import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { PrintAreaCustomization } from "@/models";
import Editor from "@/components/PrintAreaCustomization/Editor.vue";
import { CustomizationMode } from "@/models/types";

@Component({
  components: {
    Editor,
  },
})
export default class PrintAreaCustomizationWrapper extends Vue {
  @Prop({ required: true }) readonly value!: PrintAreaCustomization;

  printAreaCustomization: PrintAreaCustomization = this.value;
  showEditor = true;

  @Watch("value")
  onValueChanged(value: PrintAreaCustomization) {
    this.showEditor = false;
    this.printAreaCustomization = value;
    this.$nextTick(() => {
      this.showEditor = true;
    });
  }

  onPreview(mode: CustomizationMode) {
    this.$emit("preview", mode);
  }

  addToCart(){
    (this.$refs.editor as any).addToCart();
  }

  goToCart(){
    (this.$refs.editor as any).goToCart();
  }
}
